import React, { Component } from "react";

import { UISref } from "@uirouter/react";
import { colors, brands } from "assets";
import { StyledButton } from "components/support";
import UserInfo from "./user-info";
import Icon from "material-ui-next/Icon";

import "./topbar.css";

class TopbarView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const {
      userInfo,
      displayCompanyChangeModal,
      multilocalityOpen,
      companySearchOptions
    } = viewModel;
    const { name, id } = userInfo;

    return (
      <div className="topbar" style={{ backgroundColor: colors.primary.dark }}>
        <StyledButton
          flat
          className="topbar__menu-button"
          onClick={() => presenter.doMenuClick()}
          leftIcon={<Icon style={{ border: "none", margin: 0 }}>menu</Icon>}
        />
        <UISref to="app.history.dashboard" className="topbar__logo">
          <img
            src={brands.png.topbarLogo}
            style={{ maxHeight: 30 }}
            alt="PDVend"
          />
        </UISref>
        <UserInfo
          name={name}
          id={id}
          onCompanyChange={() => presenter.doCompanyChange()}
          onEditInfo={() => presenter.doEditInfo()}
          onLogout={() => presenter.doLogout()}
          onHelp={() => presenter.onToggleHelp()}
          displayCompanyChangeModal={displayCompanyChangeModal}
          multilocalityOpen={multilocalityOpen}
          onClose={() => presenter.onMultilocalityClose()}
          onSelectCompany={company => presenter.onSelectCompany(company)}
          companySearchOptions={companySearchOptions}
        />
      </div>
    );
  }
}

export default TopbarView;



// WEBPACK FOOTER //
// ./src/components/support/topbar/view.jsx